import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import ChannelGroupType from '@avtechsoftware/ra-javascript-utilities/src/types/ChannelGroupType';
import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';

class ChannelTypeFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.CHANNEL_TYPE;
    this.displayName = 'Channel Type';
    this.description = 'includes...';
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'ANY of the following:',
      [OperatorTypes.NOT_EQUAL_TO]: 'NONE of the following',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  // eslint-disable-next-line class-methods-use-this
  getDisplayValue1(value) {
    const splitPartialChanKey = value.split('_');
    const chanGroupTypeId = parseInt(splitPartialChanKey[0], 10);
    const chanTypeId = parseInt(splitPartialChanKey[1], 10);
    const chanIndex = parseInt(splitPartialChanKey[2], 10);
    const channel = ChannelService.getChannelGroupChannel(chanGroupTypeId, chanIndex, chanTypeId);
    return channel.displayName;
  }

  // eslint-disable-next-line class-methods-use-this
  fromDisplayValue1(value) {
    const chanGroupArray = Object.values(ChannelGroupType);
    const channelTypesArr = [];
    chanGroupArray
      .forEach((chanGroup) => {
        chanGroup.channels.forEach((chan) => {
          channelTypesArr.push(chan);
        });
      });
    const foundChannelType = channelTypesArr
      .find((channel) => channel.displayName === value);

    return foundChannelType ? foundChannelType.channelType.id : -1;
  }

  // eslint-disable-next-line class-methods-use-this
  getValueSelectOptions() {
    // non alertable channel names
    const invalidChannels = [
      'Discovery Status',
      'Fault Code',
      'Power Source',
      'Ping State',
      'Signal Strength',
      'Connected SSID',
      'Firmware Version',
      'Motion Detected',
      'Ping IP',
      'Soft AP Enabled',
      'Soft AP IP Address',
      'Response Code',
      'Response Time',
      'Wifi Signal Strength',
    ];
    const chanGroupArray = Object.values(ChannelGroupType)
    // filter out thresholdRange sensor
      .filter((chanGroup) => chanGroup.id !== 9000);
    const channelsMap = {};
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const chanGroupKey in chanGroupArray) {
      const chanGroup = chanGroupArray[chanGroupKey];
      chanGroup.channels.forEach((channel) => {
        if (channelsMap[channel.displayName]) {
          channelsMap[channel.displayName].push(`${chanGroup.id}_${channel.channelType.id}_${channel.index}`);
        } else {
          channelsMap[channel.displayName] = [`${chanGroup.id}_${channel.channelType.id}_${channel.index}`];
        }
      });
    }
    const optionsArray = Object.entries(channelsMap)
      .filter(([displayName]) => !displayName.startsWith('SCS') && !invalidChannels.includes(displayName))
      .map(([displayName, values]) => ({
        label: displayName,
        value: values,
        channelTypeId: Number(values[0].split('_')[1]),
      }));
    return optionsArray
    // sort alphabetically
      .sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  getTooltip(filtersByOperatorObj) {
    return `Channel type is ${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
        ? `ANY of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
          .map((filter) => this.getDisplayValue1(filter.value1))
          .filter((val, index, self) => self.indexOf(val) === index)
          .join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
        ? ` NONE of ${filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
          .map((filter) => this.getDisplayValue1(filter.value1))
          .filter((val, index, self) => self.indexOf(val) === index)
          .join(', ')
        };`
        : ''
    }`;
  }
}
export default ChannelTypeFacet;
